"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParametersInvalidBeaconError = void 0;
const __1 = require("..");
class ParametersInvalidBeaconError extends __1.BeaconError {
    constructor() {
        super(__1.BeaconErrorType.PARAMETERS_INVALID_ERROR, 'Some of the parameters you provided are invalid and the request could not be completed. Please check your inputs and try again.');
        this.name = 'ParametersInvalidBeaconError';
        this.title = 'Parameters Invalid';
    }
}
exports.ParametersInvalidBeaconError = ParametersInvalidBeaconError;
//# sourceMappingURL=ParametersInvalidBeaconError.js.map